const ChevronRightDouble = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <path d="m23 31.294 2.972 2.677 8.544-9.485L25.972 15 23 17.677l6.132 6.808L23 31.294Z" />
        <path d="m14 31.294 2.972 2.677 8.544-9.485L16.972 15 14 17.677l6.132 6.808L14 31.294Z" />
    </svg>
);

export default ChevronRightDouble;
